import { render, staticRenderFns } from "./modalEditWileyModalityObj.vue?vue&type=template&id=760b27ff&"
import script from "./modalEditWileyModalityObj.vue?vue&type=script&lang=js&"
export * from "./modalEditWileyModalityObj.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports